import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/team.jpg";
import "../Profiles/Profile.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import XIcon from "@mui/icons-material/X";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import Card11 from "../Images/Profiles/Patrick (2).jpg";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function PatrickWaweyo() {
  return (
    <div className="ne-page">
      <SEO
        title="Mr. Patrick Waweyo - IT Officer / Data Manager"
        description="Mr. Patrick Waweyo is the IT Officer / Data Manager at CIRCODU with a Bachelor's Degree in Computer Engineering."
        keywords="Patrick Waweyo, IT Officer, Data Manager, CIRCODU, Bachelor's Degree, Computer Engineering"
        url="/patrick-waweyo"
        image={Card11}
        type="profile"
      />

      {/* ── Hero banner ─────────────────────────────── */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Mr. Patrick Waweyo</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">The Team</Breadcrumb.Item>
            <Breadcrumb.Item className="text1" href="/the-team/the-staff-team">
              The Staff Team
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Mr. Patrick Waweyo
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Profile section ─────────────────────────── */}
      <section className="profile-section border-bottom">
        <div className="container">
          <div className="profile-card">
            {/* Green banner strip */}
            <div className="profile-card__banner" />

            {/* Photo + name/role */}
            <div className="profile-card__header">
              <div className="profile-card__photo-wrap">
                <img src={Card11} alt="Mr. Patrick Waweyo" />
              </div>
              <div className="profile-card__identity">
                <h1 className="profile-card__name">Mr. Patrick Waweyo</h1>
                <p className="profile-card__role">IT Officer / Data Manager</p>
              </div>
            </div>

            {/* Accent divider */}
            <div className="profile-card__divider" />

            {/* Biography */}
            <div className="profile-card__body">
              <div className="texty">
                <p>
                  Patrick Waweyo is a computer engineer whose career journey has
                  spanned education, technology, and environmental advocacy. He
                  holds a Bachelor's degree in Computer Engineering from
                  Makerere University in Kampala, Uganda. His commitment to
                  fostering learning and innovation is evident through his
                  multifaceted professional experiences.
                </p>
                <p>
                  Commencing his career as a lecturer at the Management Training
                  and Advisory Centre Nakawa, Uganda (MTAC), Patrick played a
                  pivotal role in equipping students with the skills needed for
                  enterprise development. As a member of the Information and
                  Communication Technology (ICT) department, he not only
                  imparted technical expertise but also mentored and guided
                  aspiring computer professionals, nurturing their talents and
                  instilling a foundation for their future accomplishments.
                </p>
                <p>
                  As the IT officer and Data Manager at CIRCODU, Patrick has
                  showcased his adeptness in information systems, data &
                  database management, data analysis, and website design &
                  upkeep. Besides all that, he is also actively engaged in
                  research and projects geared towards promoting indoor air
                  pollution reduction and the promotion of eco-friendly
                  practices and technologies, such as improved cookstoves and
                  biogas solutions, underscores his dedication and commitment to
                  a healthier and more sustainable future.
                </p>
                <p>
                  Patrick's overarching passion for capacity building remains a
                  driving force. He eagerly embraces new opportunities that
                  enable him to further enrich his skill set and knowledge.
                  Armed with a diverse background, Patrick is poised to make
                  meaningful contributions across various domains, including
                  computing and technology, academia, and non-profit work. His
                  unique blend of experience and dedication positions him as a
                  catalyst for positive change within society, embodying the
                  values of education, innovation, and environmental
                  stewardship.
                </p>
              </div>
            </div>

            {/* Social links */}
            <div className="profile-card__socials">
              <a
                href="https://www.linkedin.com/in/patrickwaweyo/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--linkedin"
                aria-label="LinkedIn"
              >
                <LinkedInIcon />
                <span>LinkedIn</span>
              </a>

              <a
                href="https://twitter.com/NtabuPaddy"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--twitter"
                aria-label="X / Twitter"
              >
                <XIcon />
                <span>Twitter / X</span>
              </a>

              <a
                href="https://www.facebook.com/Circodu/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--facebook"
                aria-label="Facebook"
              >
                <FacebookOutlinedIcon />
                <span>Facebook</span>
              </a>

              <a
                href="https://wa.me/256705807536"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--whatsapp"
                aria-label="WhatsApp"
              >
                <WhatsAppIcon />
                <span>WhatsApp</span>
              </a>

              <a
                href="mailto:patrick.waweyo@circodu.org.ug"
                className="profile-card__social-btn profile-card__social-btn--email"
                aria-label="Email"
              >
                <EmailIcon />
                <span>Email</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default PatrickWaweyo;
